import { CSSProperties } from 'react';
import { useTheme } from '@mui/material';

export const VATIcon = ({ style }: { style?: CSSProperties }) => {
    const theme = useTheme();
    const primaryColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="VATAmountIcon"
            style={style}
        >
            <rect x="10.5" y="11.5" width="5" height="1" rx="0.5" fill={primaryColor} />
            <rect
                x="13.5"
                y="9.5"
                width="5"
                height="1"
                rx="0.5"
                transform="rotate(90 13.5 9.5)"
                fill={primaryColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 3.5H12.5V8C12.5 8.27614 12.7239 8.5 13 8.5C13.2761 8.5 13.5 8.27614 13.5 8V3.5C13.5 2.94772 13.0523 2.5 12.5 2.5H4.5C3.94772 2.5 3.5 2.94772 3.5 3.5V12.7338C3.5 13.5111 4.34797 13.9912 5.0145 13.5913L5.4855 13.3087C5.80219 13.1187 6.19781 13.1187 6.5145 13.3087L7.9855 14.1913C8.30219 14.3813 8.69781 14.3813 9.0145 14.1913L10.0568 13.5659C10.2935 13.4239 10.3703 13.1167 10.2283 12.88C10.0862 12.6432 9.77905 12.5664 9.54226 12.7085L8.5 13.3338L7.02899 12.4512C6.39563 12.0712 5.60437 12.0712 4.97101 12.4512L4.5 12.7338V3.5Z"
                fill="url(#paint0_linear_424_1771)"
            />
            <rect x="5.5" y="5.5" width="6" height="1" rx="0.5" fill="currentColor" />
            <rect x="5.5" y="8.5" width="6" height="1" rx="0.5" fill="currentColor" />
            <defs>
                <linearGradient
                    id="paint0_linear_424_1771"
                    x1="8"
                    y1="7.5"
                    x2="14"
                    y2="13.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor={primaryColor} />
                </linearGradient>
            </defs>
        </svg>
    );
};
